import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["src"];
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  key: 0,
  style: {
    "color": "red"
  }
};
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "block"
};
import { reactive, getCurrentInstance, ref, onMounted, onUnmounted } from 'vue';
import { ElMessage } from 'element-plus';
import defaulImg from '../../../assets/defaulImg.jpg';
import { projectMangeSearch_data } from '../../../utils/lc_data';
import { exportlist } from '../../../utils/lc';
import { useRouter } from 'vue-router';
/* 数据层 */

export default {
  __name: 'index',
  setup(__props) {
    let router = useRouter();
    // 基本信息组件值
    const {
      proxy
    } = getCurrentInstance();
    let formdata = reactive(JSON.parse(JSON.stringify(projectMangeSearch_data)));
    const data = reactive({
      prlistTtable: [],
      xtshow: false,
      selRow: [],
      checked: true,
      // 我的待办
      total: 0,
      projectId: '',
      page: 1
    });
    /* 初始化 */
    const theSearch = ref();
    const keyDown = e => {
      if (e.keyCode == 13 || e.keyCode == 100) {
        searchhandle(JSON.parse(JSON.stringify(theSearch.value.theformdata)));
      }
    };
    onMounted(() => {
      if (window.sessionStorage.getItem("projectSearchdata")) {
        formdata = theSearch.value.theformdata;
        data.checked = formdata.my == '1' ? true : false;
      }
      getlist();
      //绑定监听事件
      window.addEventListener('keydown', keyDown);
    });
    onUnmounted(() => {
      //销毁事件
      window.removeEventListener('keydown', keyDown, false);
    });
    /* 方法层 */
    // 表格操作
    function init() {
      data.page = 1;
      getlist();
    }
    function selectionChange(val) {
      data.selRow = val.records;
    }
    function mychange(val) {
      formdata = JSON.parse(JSON.stringify(theSearch.value.theformdata));
      theSearch.value.theformdata.my = val ? '1' : '0';
      formdata.my = val ? 1 : 0;
      getlist();
    }
    function getClickBtnType(type, selRow, value) {
      //打开日志
      if (type == 'log') {
        router.push({
          path: '/lcProject/log/prlog'
        });
      }
      //新增项目
      if (type == 'addProject') {
        router.push({
          path: '/lcProject/projectMange/add'
        });
      }
      // 导出规格定义表
      if (type == 'exportTablbt') {
        if (data.selRow.length > 0) {
          let project_ids = data.selRow.map((obj, index) => {
            return obj.id;
          }).join(",");
          exportlist('', project_ids, 'projectList', 'sku', '规格定义表');
        } else {
          ElMessage.error('请先勾选要导出的项目!');
        }
      }
      // 我的待办
      if (type === 'check_box') {
        formdata.page = 1;
        formdata.my = data.checked ? '1' : '0';
        getlist();
      }
    }

    //获取列表数据
    function getlist() {
      let sudata = JSON.parse(JSON.stringify(formdata));
      sudata.plan_start_time = sudata.plan_start_time && sudata.plan_start_time.length > 0 ? sudata.plan_start_time.join('-') : '';
      sudata.plan_end_time = sudata.plan_end_time && sudata.plan_end_time.length > 0 ? sudata.plan_end_time.join('-') : '';
      sudata.start_time = sudata.start_time && sudata.start_time.length > 0 ? sudata.start_time.join('-') : '';
      sudata.end_time = sudata.end_time && sudata.end_time.length > 0 ? sudata.end_time.join('-') : '';
      sudata.online_time = sudata.online_time && sudata.online_time.length > 0 ? sudata.online_time.join('-') : '';
      sudata.product_time = sudata.product_time && sudata.product_time.length > 0 ? sudata.product_time.join('-') : '';
      proxy.$http.showLoading(false).get('project/project/list', sudata).then(res => {
        if (res.errno == 200) {
          data.prlistTtable = res.data.data;
          data.total = res.data.total;
        }
      });
    }
    // 搜索
    function searchhandle(value) {
      if (value) {
        formdata = value;
      }
      formdata.my = data.checked ? '1' : '0';
      formdata.page = 1;
      getlist();
      console.log('搜索', value);
    }
    // 重置
    function resethandel() {
      formdata = JSON.parse(JSON.stringify(projectMangeSearch_data));
      formdata.my = 1;
      data.page = 1;
      formdata.page = 1;
      data.checked = true;
      getlist();
    }
    //分页条数
    function handleSizeChange(val) {
      formdata.size = val;
      data.page = 1;
      formdata.page = 1;
      getlist();
    }
    function pusdown(row) {
      data.projectId = row.id;
      data.xtshow = true;
    }
    // 获取路由跳转信息
    function getRouteInfo(row) {
      router.push({
        path: '/lcProject/projectMange/edit',
        query: {
          id: row.id
        }
      });
    }
    //分页数
    function handleCurrentChange(val) {
      formdata.page = val;
      data.page = val;
      getlist();
    }
    function handelClose() {
      data.xtshow = false;
    }
    return (_ctx, _cache) => {
      const _component_lcSearch = _resolveComponent("lcSearch");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_vxe_toolbar = _resolveComponent("vxe-toolbar");
      const _component_vxe_column = _resolveComponent("vxe-column");
      const _component_vxe_table = _resolveComponent("vxe-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_lcDailogxt = _resolveComponent("lcDailogxt");
      const _component_el_main = _resolveComponent("el-main");
      return _openBlock(), _createBlock(_component_el_main, {
        class: "bg_white wrap_box lcpg"
      }, {
        default: _withCtx(() => [_createVNode(_component_lcSearch, {
          class: "lcS",
          ref_key: "theSearch",
          ref: theSearch,
          onSearchhandle: searchhandle,
          onResethandel: resethandel
        }, null, 512), _createElementVNode("div", null, [_createVNode(_component_vxe_toolbar, null, {
          buttons: _withCtx(() => [_createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = $event => getClickBtnType('addProject')),
            class: "l-button"
          }, "新增项目"), _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = $event => getClickBtnType('exportTablbt')),
            class: "l-button"
          }, "导出规格定义表"), _createElementVNode("div", {
            onClick: _cache[2] || (_cache[2] = $event => getClickBtnType('log')),
            class: "l-button"
          }, "日志"), _createElementVNode("div", null, [_createVNode(_component_el_checkbox, {
            modelValue: data.checked,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => data.checked = $event),
            label: "我的待办",
            onChange: mychange
          }, null, 8, ["modelValue"])])]),
          _: 1
        }), _createVNode(_component_vxe_table, {
          id: "wlbjtable",
          onCheckboxChange: selectionChange,
          onCheckboxAll: selectionChange,
          "max-height": "550",
          "custom-config": {
            storage: true
          },
          border: "",
          "show-overflow": "",
          data: data.prlistTtable,
          "keep-source": "",
          "column-config": {
            resizable: true
          },
          "edit-config": {
            trigger: 'click',
            mode: 'cell',
            showUpdateStatus: true,
            showInsertStatus: true
          },
          class: "ggdycss"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_column, {
            type: "checkbox",
            width: "50",
            align: "center"
          }), _createVNode(_component_vxe_column, {
            field: "code",
            title: "项目代码",
            width: "80",
            align: "left"
          }), _createVNode(_component_vxe_column, {
            title: "项目图片",
            width: "100",
            align: "center"
          }, {
            default: _withCtx(scope => [_createElementVNode("img", {
              src: scope.row.image ? scope.row.image : _unref(defaulImg),
              class: "avatar",
              onError: _cache[4] || (_cache[4] = e => {
                e.target.src = _unref(defaulImg);
              })
            }, null, 40, _hoisted_1)]),
            _: 1
          }), _createVNode(_component_vxe_column, {
            title: "项目名称",
            width: "160",
            align: "left"
          }, {
            default: _withCtx(({
              row
            }) => [_createElementVNode("span", {
              style: {
                "color": "#409eff",
                "cursor": "pointer"
              },
              onClick: $event => getRouteInfo(row)
            }, _toDisplayString(row.name), 9, _hoisted_2)]),
            _: 1
          }), _createVNode(_component_vxe_column, {
            field: "leader_user_name",
            title: "项目负责人",
            width: "100",
            align: "left"
          }), _createVNode(_component_vxe_column, {
            field: "task_text",
            title: "当前任务及状态",
            align: "left"
          }), _createVNode(_component_vxe_column, {
            field: "status_text",
            title: "项目状态",
            width: "100",
            align: "center"
          }), _createVNode(_component_vxe_column, {
            field: "level",
            title: "项目优先级",
            width: "100",
            align: "center"
          }, {
            default: _withCtx(({
              row
            }) => [row.level_text == '优先' ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(row.level_text), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(row.level_text), 1))]),
            _: 1
          }), _createVNode(_component_vxe_column, {
            field: "plan_start_time",
            title: "项目预计开始日期",
            width: "120",
            align: "center"
          }), _createVNode(_component_vxe_column, {
            field: "plan_end_time",
            title: "项目预计结束日期",
            width: "120",
            align: "center"
          }), _createVNode(_component_vxe_column, {
            field: "start_time",
            title: "项目开始日期",
            width: "100",
            align: "center"
          }), _createVNode(_component_vxe_column, {
            field: "issue_time",
            title: "项目发布日期",
            width: "100",
            align: "center"
          }), _createVNode(_component_vxe_column, {
            field: "product_time",
            title: "项目量产日期",
            width: "100",
            align: "center"
          }), _createVNode(_component_vxe_column, {
            field: "online_time",
            title: "项目上架日期",
            width: "100",
            align: "center"
          }), _createVNode(_component_vxe_column, {
            field: "end_time",
            title: "项目结束日期",
            width: "100",
            align: "center"
          }), _createVNode(_component_vxe_column, {
            title: "操作",
            width: "100",
            align: "center",
            fixed: "right"
          }, {
            default: _withCtx(({
              row
            }) => [_createElementVNode("span", {
              style: {
                "color": "#409eff",
                "cursor": "pointer"
              },
              onClick: $event => pusdown(row)
            }, "下推", 8, _hoisted_5)]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_pagination, {
          background: "",
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange,
          "current-page": data.page,
          "page-sizes": [50, 100, 150],
          "page-size": _unref(formdata).size,
          layout: "total, sizes, prev, pager, next, jumper",
          total: data.total
        }, null, 8, ["current-page", "page-size", "total"])])]), data.xtshow ? (_openBlock(), _createBlock(_component_lcDailogxt, {
          key: 0,
          onHandelClose: handelClose,
          xtshow: data.xtshow,
          "onUpdate:xtshow": _cache[5] || (_cache[5] = $event => data.xtshow = $event),
          projectId: data.projectId,
          onGetinit: init
        }, null, 8, ["xtshow", "projectId"])) : _createCommentVNode("", true)]),
        _: 1
      });
    };
  }
};